import { useMemo} from 'react';
import { useInView } from 'react-intersection-observer';

import { Image } from "@/snippets/components/Image";
import Link from 'next/link';
import { useWindowDimensions } from "@/utils/Helper";

export function CollectionPromoTile({ tile, index = 0 }) {
  const { ref, inView } = useInView({
    rootMargin: '0px',
    triggerOnce: true,
  });

  const { aspectRatio, background, link } = tile;
  const { alt, d_image, m_image } = {
    ...background,
  };
  const { vpWidth } = useWindowDimensions();

  const belowFold = useMemo(() => {
    if (vpWidth < 768) return index >= 2 ? true : false;
    else return index >= 5 ? true : false;
    return true;
  }, [vpWidth, index]);

  return (
    <div className="h-full">
    {link?.url ? (
      <div className={`relative ${aspectRatio} overflow-hidden plp-promo-image-cta`}>
        <Link href={link?.url}>
          <a className={`no-underline hover:underline`}
            aria-label={link?.text || alt || link?.url}
          >
            {d_image?.src && (
              <Image
                alt={alt}
                fill
                sizes="(min-width: 768px) 33vw, 50vw"
                src={d_image.src}
                width="400"
                height="500"
                className="hidden md:block"
                loading={belowFold ? 'lazy' : 'eager'}
              />
            )}
           {m_image?.src && (
              <Image
                alt={alt}
                fill
                sizes="(max-width: 767px) 33vw, 50vw"
                width="337"
                height="555"
                src={m_image.src}
                className="block md:hidden"
                loading={belowFold ? 'lazy' : 'eager'}
              />
            )}
            {link?.text && (
            <div className="absolute bottom-0 w-full p-4">
              <button type="button" className="button button--primary !min-w-full">
                {link?.text}
              </button>
            </div>
            )}
          </a>
        </Link>
      </div>
    ) : (
      <div className={`relative ${aspectRatio} overflow-hidden plp-promo-image-only`}>
       {d_image?.src && (
          <Image
            alt={alt}
            fill
            sizes="(min-width: 768px) 33vw, 50vw"
            width="400"
            height="500"
            src={d_image.src}
            className="hidden md:block"
            loading={belowFold ? 'lazy' : 'eager'}
          />
        )}
       {m_image?.src && (
          <Image
            alt={alt}
            fill
            sizes="(max-width: 767px) 33vw, 50vw"
            width="337"
            height="555"
            src={m_image.src}
            className="block md:hidden"
            loading={belowFold ? 'lazy' : 'eager'}
          />
        )}
      </div>
    )}
    </div>
  );
}

CollectionPromoTile.displayName = 'CollectionPromoTile';